/**
 * Collapses SES tracking-pixel echoes in an email_events list.
 *
 * SES regularly reports the same Open (or Click) twice within a second or
 * two for one email, so raw rows read as "opened four times" when the
 * customer opened twice. This drops an event when the previous kept event
 * for the SAME email has the same event type and lands in the same minute.
 * Distinct opens (minutes or days apart) are all kept.
 *
 * "Same email" = email_type + recipient address + transaction_id. Input
 * order is preserved (tables list newest first, the drawer chain oldest
 * first), so callers can pass whatever order they render in.
 */

function minuteBucket(timestamp) {
  const ms = new Date(timestamp).getTime()
  return Number.isNaN(ms) ? null : Math.floor(ms / 60000)
}

function emailKey(e) {
  return [
    e.email_type || 'unknown',
    (e.customer_email || '').toLowerCase(),
    e.transaction_id == null ? '' : String(e.transaction_id)
  ].join('|')
}

export function collapseEmailEvents(events) {
  if (!Array.isArray(events) || events.length === 0) return []

  const ascending = events
    .map((e, index) => ({ e, index }))
    .filter(({ e }) => e && e.timestamp)
    .sort((a, b) => {
      const diff = new Date(a.e.timestamp) - new Date(b.e.timestamp)
      if (diff !== 0) return diff
      return (a.e.id || 0) - (b.e.id || 0)
    })

  const dropped = new Set()
  const lastKept = new Map()
  for (const { e, index } of ascending) {
    const key = emailKey(e)
    const bucket = minuteBucket(e.timestamp)
    const prev = lastKept.get(key)
    if (prev && prev.event_type === e.event_type && bucket !== null && prev.bucket === bucket) {
      dropped.add(index)
      continue
    }
    lastKept.set(key, { event_type: e.event_type, bucket })
  }

  return events.filter((e, index) => !dropped.has(index))
}
